export default __webpack_public_path__ + "static/media/Boots of the Wells of Night.fa348535.jpg";